import {
  Card,
  Divider,
  Grid,
  Typography,
  Dialog,
  DialogTitle,
  IconButton,
  CardContent,
  Box
} from '@mui/material'
// import { makeStyles } from '@mui/material/styles'
import { Close } from '@mui/icons-material'
import { useTheme } from '@mui/material/styles';


function CustomerInfoDialog({ visible, cancelText, initialValues, onCancel, title }) {
  if (initialValues == undefined) {
    initialValues = {}
  }

  const theme = useTheme();
  return (
    <>
      <Dialog
        maxWidth='sm'
        fullWidth
        open={visible}
        aria-labelledby="form-dialog-title"

      >
        <DialogTitle sx={{ "display": "flex", "justifyContent": "space-between", alignItems: "center" }}>
          {title}
          <IconButton
            component="span"
            size='small'
            sx={{ ':hover': { backgroundColor: "red", color: "white" } }}
            onClick={onCancel}
            variant="contained"
          >
            <Close />
          </IconButton>
        </DialogTitle>
        <Box sx={{ background: theme.palette.background.gray }} >
          <Divider />
          <Grid container spacing={6} sx={{ paddingBottom: 3 }} direction="column">
            <Grid item>
              <Card raised sx={{ borderRadius: 3, height: '100%', display: 'flex', flexDirection: 'column' }}>
                <CardContent sx={{ flexGrow: 1 }}>
                  <Grid container spacing={3}>
                    <Grid item md={6}>
                      <Typography style={{ fontSize: 14 }} gutterBottom>
                        Name : {initialValues?.name}
                      </Typography>
                    </Grid>
                    <Grid item md={6}>
                      <Typography style={{ fontSize: 14 }} gutterBottom>
                        Mobile : {initialValues?.mobile}
                      </Typography>
                    </Grid>

                  </Grid>
                  <Grid container spacing={3} paddingTop={1}>
                    <Grid item md={6}>
                      <Typography style={{ fontSize: 14 }} gutterBottom>
                        Address : {initialValues?.address}
                      </Typography>
                    </Grid>
                    <Grid item md={6}>
                      <Typography style={{ fontSize: 14 }} gutterBottom>
                        Email : {initialValues?.email}
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid container spacing={3} paddingTop={1}>
                    <Grid item md={6}>
                      <Typography style={{ fontSize: 14 }} gutterBottom>
                        GSTN : {initialValues?.gstn}
                      </Typography>
                    </Grid>
                    <Grid item md={4}>
                      <Typography style={{ fontSize: 14 }} gutterBottom>
                        Pincode : {initialValues?.pincode}
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid container spacing={3} paddingTop={1}>
                    <Grid item md={4}>
                      <Typography style={{ fontSize: 14 }} gutterBottom>
                        City : {initialValues?.city}
                      </Typography>
                    </Grid>
                    <Grid item md={4}>
                      <Typography style={{ fontSize: 14 }} gutterBottom>
                        State : {initialValues?.state}
                      </Typography>
                    </Grid>
                    <Grid item md={4}>
                      <Typography style={{ fontSize: 14 }} gutterBottom>
                        Country : {initialValues?.country}
                      </Typography>
                    </Grid>
                  </Grid>
                  <Divider my={3} />
                  {initialValues?.contactperson?.map((contactperson, i) => (
                    <div key={i}>
                      <Box sx={{ textAlign: "center" }} >
                        <Typography
                          style={{ fontSize: 14, fontWeight: 'bold', marginTop: 5 }}
                          gutterBottom
                        >
                          Contact Person {i + 1}
                        </Typography>
                      </Box>
                      <Divider spacing={6} />
                      <Grid container spacing={3} paddingTop={1}>
                        <Grid item md={6}>
                          <Typography style={{ fontSize: 14 }} gutterBottom>
                            First Name : {contactperson?.first_name}
                          </Typography>
                        </Grid>
                        <Grid item md={6}>
                          <Typography style={{ fontSize: 14 }} gutterBottom>
                            Last Name : {contactperson?.last_name}
                          </Typography>
                        </Grid>
                      </Grid>
                      <Grid container spacing={3} paddingTop={1}>
                        <Grid item md={6}>
                          <Typography style={{ fontSize: 14 }} gutterBottom>
                            Mobile : {contactperson?.mobile}
                          </Typography>
                        </Grid>
                        <Grid item md={6}>
                          <Typography style={{ fontSize: 14 }} gutterBottom>
                            Email : {contactperson?.email}
                          </Typography>
                        </Grid>
                      </Grid>
                      <Grid container spacing={3} paddingTop={1}>
                        <Grid item md={6}>
                          <Typography style={{ fontSize: 14 }} gutterBottom>
                            Comments : {contactperson?.comments}
                          </Typography>
                        </Grid>
                        <Grid item md={6}>
                          <Typography style={{ fontSize: 14 }} gutterBottom>
                            Telephone : {contactperson?.telephone}
                          </Typography>
                        </Grid>
                      </Grid>
                      <Divider spacing={6} />
                    </div>
                  ))}
                </CardContent>
              </Card>
            </Grid>
            {/* <Grid item>
                  <Grid item md={6} style={{ paddingTop: 8 }}>
                    <Button onClick={onCancel} variant="contained" mt={3}>
                      {cancelText}
                    </Button>
                  </Grid>
                </Grid> */}
          </Grid>
          {/* </CardContent> */}
          {/* </Card> */}
        </Box>
      </Dialog>
    </>
  )
}

export default CustomerInfoDialog
